import type { SettlementItem } from "../../types";

interface SettlementsTableProps {
  invoices: SettlementItem[];
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  formatOverdue: (value?: number | string) => string;
}

const SettlementsTable = ({
  invoices,
  formatDate,
  formatCurrency,
  formatOverdue,
}: SettlementsTableProps) => (
  <table>
    <thead>
      <tr>
        <th>Numer</th>
        <th>Data wystawienia</th>
        <th>Kwota brutto</th>
        <th>Pozostało</th>
        <th>Warunki płatności</th>
        <th>Termin płatności</th>
        <th>Dni po terminie</th>
      </tr>
    </thead>
    <tbody>
      {invoices.map((invoice) => {
        const overdue = Number(invoice.overdueDays || 0);
        const issued = formatDate(invoice.issuedAt);
        const due = formatDate(invoice.dueDate);

        return (
          <tr
            key={`${invoice.invoiceNumber}-${invoice.issuedAt}`}
            className={overdue > 0 ? "overdue" : ""}
          >
            <td data-label="Numer">{invoice.invoiceNumber || "-"} </td>
            <td data-label="Data wystawienia">{issued || "-"}</td>
            <td data-label="Kwota brutto">
              {formatCurrency(invoice.grossAmount)}
            </td>
            <td data-label="Pozostało">{formatCurrency(invoice.amountDue)}</td>
            <td data-label="Warunki">{invoice.paymentTermsCode || "-"}</td>
            <td
              data-label="Termin płatności"
              className={overdue > 0 ? "overdue-text" : ""}
            >
              {due || "-"}
            </td>
            <td
              data-label="Dni po terminie"
              className={overdue > 0 ? "overdue-text" : ""}
            >
              {formatOverdue(invoice.overdueDays)}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default SettlementsTable;
